// assets/custom.js

// 外部リンクは全て新しいタブで開く
document.addEventListener('DOMContentLoaded', function () {
  const currentOrigin = window.location.origin;

  document.querySelectorAll('a[href]').forEach(function (link) {
    // 明示的に target が指定されている場合は尊重
    if (link.hasAttribute('target')) {
      return;
    }

    const href = link.getAttribute('href');

    // 除外：アンカー単体 / JS / mail / tel
    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('javascript:') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:')
    ) {
      return;
    }

    try {
      const url = new URL(href, window.location.origin);

      // 同一オリジン（ドメイン + プロトコル）は内部リンク
      if (url.origin === currentOrigin) {
        return;
      }

      // 外部リンクのみ
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener');

    } catch (e) {
      // URLとして解釈できないものは無視
    }
  });
});

// アンカー月の遷移の場合ターゲットIDより指定したpx分上に遷移する
(function () {
  const OFFSET = 120; // 上にずらしたいpx数（ヘッダー分）

  function adjustAnchorScroll() {
    if (!window.location.hash) return;

    const targetId = window.location.hash.substring(1);
    const targetEl = document.getElementById(targetId);

    if (!targetEl) return;

    const elementPosition = targetEl.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - OFFSET;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  // ページ読み込み時（別ページ＋アンカー）
  window.addEventListener('load', function () {
    setTimeout(adjustAnchorScroll, 50);
  });

  // ページ内アンカークリック時
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href^="#"], a[href*="#"]');
    if (!link) return;

    const href = link.getAttribute('href');
    const hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;

    const hash = href.substring(hashIndex);

    // URLを書き換えてから補正
    history.pushState(null, '', hash);
    setTimeout(adjustAnchorScroll, 10);
  });
})();

// 初期表示用：チェックされているカラーを legend に反映
function initColorLabels() {
  var colorFieldsets = document.querySelectorAll(
    '.product-parameters .product-form__controls--colors'
  );

  colorFieldsets.forEach(function (fs) {
    var span = fs.querySelector('[data-color-name-id]');
    if (!span) return;

    var checked = fs.querySelector('input[type="radio"]:checked');
    if (checked) {
      span.textContent = checked.value;
    }
  });
}

// 変更時用：クリックしたカラーを legend に反映
function bindColorChange() {
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.product-parameters input[type="radio"]')) return;

    var fs = e.target.closest('.product-form__controls--colors');
    if (!fs) return;

    var span = fs.querySelector('[data-color-name-id]');
    if (!span) return;

    span.textContent = e.target.value;
  });
}

(function () {
  // 通常ロード時
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initColorLabels();
      bindColorChange();
    });
  } else {
    initColorLabels();
    bindColorChange();
  }

  // テーマエディタでセクション再読込されたとき
  document.addEventListener('shopify:section:load', function () {
    initColorLabels();
  });
})();